import {Injectable} from '@angular/core';
import CooperationInsightModel from '../../model/cooperationInsight.model';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError, switchMap} from 'rxjs/operators';
import CooperationContactModel from '../../model/cooperationContact.model';
import {HttpClient} from '@angular/common/http';
import Pagination from '../../model/pagination';
import QueryEncoder from '../queryEncoder';

@Injectable()
export default class CooperationContactService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<CooperationContactModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    return this.http
      .get<Pagination<CooperationContactModel>>(environment.apiUrl + '/cooperation-contacts?' + QueryEncoder.encodeURI(q));
  }

  public show(id: number): Observable<CooperationContactModel> {
    return this.http.get<CooperationContactModel>(environment.apiUrl + '/cooperation-contacts/' + id);
  }

  public create(contact: CooperationContactModel): Observable<CooperationContactModel> {
    return this.http
      .post<CooperationContactModel>(environment.apiUrl + '/cooperation-contacts', contact);
  }

  public delete(contact: CooperationContactModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/cooperation-contacts/' + contact.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public update(contact: CooperationContactModel): Observable<boolean> {
    return this.http
      .put<CooperationContactModel>(environment.apiUrl + '/cooperation-contacts/' + contact.id, contact).pipe(
        switchMap(result => of(true)),
        catchError(result => of(false))
      );
  }



}
